export default {
    slug: 'mailboxes',
    ability: 'mailboxes',
    routes: [
        {
            path: 'emails',
            name: 'emails',
            component: () => import('./pages/Index.vue'),
            children: [
                {
                    path: 'accounts',
                    name: 'email-accounts',
                    component: () => import('./pages/accounts/List.vue'),
                    children: [
                        {
                            path: ':id(\\d+)',
                            name: 'email-account-preview',
                            component: () => import('./pages/accounts/Preview.vue'),
                            props: true
                        }
                    ]
                },
                {
                    path: ':mailbox_id(\\d+)/:folder',
                    name: 'email-list',
                    component: () => import('./pages/List.vue'),
                    props: true,
                    children: [
                        {
                            path: ':id',
                            name: 'email-preview',
                            component: () => import('./pages/Preview.vue'),
                            props: true
                        }
                    ]
                }
            ]
        }
    ],
    nav: () => ({
        section: 'crm',
        items: [
            {
                title: i18n.t('Emails'),
                icon: 'email',
                to: { name: 'emails' },
                position: 3
            }
        ]
    })
};
